// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__YgjRK","upload":"Small_upload__2pgig","imageWrap":"Small_imageWrap__3sjoC","removeBtn":"Small_removeBtn__2Su9l"};